import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, Save } from 'lucide-react';

import { ConsignmentEditForm, type ConsignmentEditFormRef } from '@/widgets/consignment-edit-form';
import { Button } from '@/components/ui/button';

import { useConsignmentCreate } from '../lib';

export function ConsignmentCreatePage() {
  const { t } = useTranslation();
  const formRef = useRef<ConsignmentEditFormRef>(null);
  const { handleSave, handleBack, prefillValues, isSrfLoading } = useConsignmentCreate();

  const handleSubmit = () => {
    formRef.current?.submit();
  };

  return (
    <div className="mx-auto py-6 space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={handleBack} aria-label={t('common.back', 'Back')}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-2xl font-bold">{t('newcmr.create.title', 'Create New Consignment')}</h1>
        </div>

        <Button size="sm" onClick={handleSubmit}>
          <Save className="h-4 w-4 mr-2" />
          {t('newcmr.create.label', 'Save New Consignment')}
        </Button>
      </div>

      <ConsignmentEditForm
        ref={formRef}
        mode="create"
        prefillValues={prefillValues}
        isLoading={isSrfLoading}
        onSave={handleSave}
      />
    </div>
  );
}
